import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import SettingsCentralMappingTablesCellsEditableTextCell from 'lumen/components/settings/central-mapping/tables/cells/editable-text-cell';
import type { CentralMappingMappingEntry } from 'lumen/models';

interface HotelSettingsCentralMappingTablesCellsTdDescriptionSignature {
  Args: {
    cellData: string;
    column: {
      isReadOnly?: boolean;
    };
    row: {
      mappingEntry: CentralMappingMappingEntry;
    };
    rowMeta: {
      isSelected: boolean;
    };
  };
}

export default class HotelSettingsCentralMappingTablesCellsTdDescription extends Component<HotelSettingsCentralMappingTablesCellsTdDescriptionSignature> {
  @service declare centralMapping: Services['central-mapping'];

  MAX_LENGTH_DESCRIPTION = 250; // Same limit of 250 as in backend

  get isReadOnly(): boolean {
    const { column, rowMeta } = this.args;

    return column.isReadOnly || !!rowMeta.isSelected;
  }

  @action
  setDescription(value: string): void {
    this.args.row.mappingEntry.description = value;

    this.centralMapping.trackMappingEntryChanged({
      mappingChange: 'description',
    });
  }

  <template>
    <SettingsCentralMappingTablesCellsEditableTextCell
      @cellDataTestId="central-mapping-td-description"
      @isReadOnly={{this.isReadOnly}}
      @maxLength={{this.MAX_LENGTH_DESCRIPTION}}
      @setValue={{this.setDescription}}
      @showTooltip={{true}}
      @value={{@cellData}}
    />
  </template>
}
